var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCerrarsesionOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico / Bottom Nav / large / cerrar sesion-outlined") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico-/-Bottom-Nav-/-large-/-cerrar-sesion-outlined",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(2.000000, 3.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.5,
    y: 0,
    width: 1,
    height: 9,
    rx: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57,18.11 C4.99780725,17.859645 1.3256226,14.2474494 1,9.68 C0.814528415,6.81932521 2.00294115,4.04141043 4.2,2.2 C4.30308573,2.11232889 4.43783903,2.07119322 4.57231321,2.08634524 C4.7067874,2.10149726 4.82900817,2.17158776 4.91,2.28 L4.91,2.28 C4.99707903,2.38603425 5.03675766,2.52319398 5.01973911,2.65934239 C5.00272055,2.7954908 4.93050041,2.91866318 4.82,3 C2.9702761,4.57005239 1.93301018,6.8947051 2,9.32 C2.06627417,13.7603694 5.71963061,17.3062742 10.16,17.24 C14.6003694,17.1737258 18.1462742,13.5203694 18.08,9.08 C18.0803982,6.70917536 17.0292097,4.46029129 15.21,2.94 C15.0033864,2.76936126 14.9640689,2.46792719 15.12,2.25 L15.12,2.25 C15.2030459,2.14188204 15.3259224,2.07151427 15.4612006,2.0546045 C15.5964787,2.03769474 15.7328957,2.07565081 15.84,2.16 C18.9136594,4.62334004 20.0283306,8.79921929 18.5911605,12.4666391 C17.1539903,16.134059 13.4989408,18.4408039 9.57,18.16 L9.57,18.11 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarsesionOutlined);
export default __webpack_public_path__ + "static/media/cerrar sesion-outlined.6dff51be53678f3879d94e176c842ab1.svg";
export { ForwardRef as ReactComponent };